import { Link } from 'react-router-dom'

import styled from 'styled-components'

export const ParcelNameLink = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: ${props => props.theme.colors.text.link.default};
`
